import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePageSeo, BASE_URL } from "@/hooks/useSeo";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ImpressumPage() {
  const [c, setC] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/company-settings`).then(r => setC(r.data)).catch(() => {});
  }, []);

  usePageSeo({
    title: "Impressum | LAB336",
    description: "Impressum von LAB336 – Angaben gemäss Schweizer Recht. Kontaktdaten, Haftungsausschluss und Urheberrecht.",
    canonical: `${BASE_URL}/impressum`,
  });

  if (!c) return <div className="min-h-screen bg-white" />;

  return (
    <div className="min-h-screen bg-white" data-testid="impressum-page">
      <header className="bg-lab-bg-dark">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-400 hover:text-lab-accent transition-colors text-sm mb-8"
            data-testid="back-to-home"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          <h1 className="font-playfair text-3xl lg:text-4xl font-semibold text-white">
            Impressum
          </h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none text-lab-text leading-relaxed space-y-8">
          <p className="text-lab-text-muted italic">Angaben gemäss Art. 3 UWG (Schweiz)</p>

          <section>
            <h2 className="font-playfair text-xl font-semibold text-lab-primary mb-3">Unternehmensname</h2>
            <p className="text-lab-text-muted" data-testid="impressum-company-name">{c.company_name}</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-semibold text-lab-primary mb-3">Adresse</h2>
            <p className="text-lab-text-muted" data-testid="impressum-address">
              {c.street}<br />
              {c.zip_city}<br />
              {c.country}
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-semibold text-lab-primary mb-3">Kontakt</h2>
            <p className="text-lab-text-muted">
              E-Mail: <a href={`mailto:${c.email}`} className="text-lab-accent hover:underline">{c.email}</a><br />
              Telefon: <a href={`tel:${c.phone?.replace(/\s/g, "")}`} className="text-lab-accent hover:underline">{c.phone}</a>
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-semibold text-lab-primary mb-3">Inhaltlich Verantwortlicher</h2>
            <p className="text-lab-text-muted">
              {c.responsible_name}<br />
              {c.responsible_company || c.company_name}<br />
              {c.responsible_address}
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-semibold text-lab-primary mb-3">Unternehmensform</h2>
            <p className="text-lab-text-muted">{c.company_form}</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-semibold text-lab-primary mb-3">UID-Nummer (Mehrwertsteuer)</h2>
            <p className="text-lab-text-muted">{c.uid_number}</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-semibold text-lab-primary mb-3">Handelsregistereintrag</h2>
            <p className="text-lab-text-muted">{c.trade_register}</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-semibold text-lab-primary mb-3">Haftungsausschluss</h2>
            <p className="text-lab-text-muted">
              Die Inhalte dieser Website wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernimmt {c.company_name} keine Gewähr. Externe Links werden zum Zeitpunkt der Verlinkung geprüft; für spätere Änderungen wird keine Haftung übernommen.
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-semibold text-lab-primary mb-3">Urheberrecht</h2>
            <p className="text-lab-text-muted">
              Alle Inhalte dieser Website (Texte, Bilder, Grafiken) sind urheberrechtlich geschützt. Eine Verwendung ohne schriftliche Genehmigung ist nicht gestattet.
            </p>
          </section>
        </div>
      </main>

      <footer className="bg-lab-bg-dark border-t border-white/10">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-8 flex items-center justify-between">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} LAB 336. Alle Rechte vorbehalten.
          </p>
          <Link to="/" className="text-gray-400 hover:text-lab-accent text-sm transition-colors">
            Startseite
          </Link>
        </div>
      </footer>
    </div>
  );
}
